import { useQuery } from "@tanstack/react-query";
import { getTestPackages } from "@/services/data";
import PackageCard from "@/components/PackageCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Package } from "lucide-react";

export default function PackagesPage() {
  const { data: packages, isLoading } = useQuery({ queryKey: ["packages"], queryFn: getTestPackages });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground mb-2">Health Checkup Packages</h1>
        <p className="text-muted-foreground">Comprehensive health panels at unbeatable prices, designed by medical experts</p>
      </div>

      {/* Banner */}
      <div className="bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20 rounded-xl p-5 mb-8 flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-primary/15 flex items-center justify-center shrink-0">
          <Package className="h-6 w-6 text-primary" />
        </div>
        <div>
          <p className="font-semibold text-foreground">Save up to 70% with health packages</p>
          <p className="text-sm text-muted-foreground">All packages include free home sample collection & digital reports on WhatsApp</p>
        </div>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="rounded-xl border border-border p-5 space-y-3">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-6 w-3/4" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-10 w-full mt-4" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages?.map(pkg => <PackageCard key={pkg.id} pkg={pkg} />)}
        </div>
      )}
    </div>
  );
}
